module.exports = __webpack_public_path__ + "img/B.40173f79.png";